import { createAction } from '@reduxjs/toolkit'

import prefix from 'modules/utils/prefix'
import { ISupportIdentifyPayload } from '../model'

export const namespaced = prefix('support')

export const IDENTIFY = namespaced('identify')
export const identify = createAction<ISupportIdentifyPayload>(IDENTIFY)
